"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var platform_browser_1 = require("@angular/platform-browser");
var core_1 = require("@angular/core");
var CroppedImageComponent = (function () {
    function CroppedImageComponent(_sanitizer) {
        this._sanitizer = _sanitizer;
        this.width = 96;
        this.alt = false;
        this.border = true;
        this.coefficient = 1;
        this.radius = 50;
    }
    Object.defineProperty(CroppedImageComponent.prototype, "imageUrl", {
        get: function () {
            if (!this.image) {
                return null;
            }
            return this.image + "?width=" + this.ampedN + "&height=" + this.ampedN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CroppedImageComponent.prototype, "ampedN", {
        get: function () {
            return this._nearestMultipleOfTwo(this.width * 1.5);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CroppedImageComponent.prototype, "croppedImageStyle", {
        get: function () {
            var tickness = Math.round((this.width * 0.05) * this.coefficient);
            var opacity = this.alt ? 0.8 : 0.3;
            var borderStyle = this.border ? "border: " + tickness + "px solid rgba(50, 50, 50, " + opacity + ");" : '';
            return this._sanitizer.bypassSecurityTrustStyle(borderStyle + " object-fit: cover; margin: auto; border-radius: " + this.radius + "%; \n                                                         position: relative; width: " + this.width + "px; height: " + this.width + "px;");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CroppedImageComponent.prototype, "textMargin", {
        get: function () {
            return Math.ceil((this.width * 0.06) * this.coefficient);
        },
        enumerable: true,
        configurable: true
    });
    CroppedImageComponent.prototype._nearestMultipleOfTwo = function (n) {
        return Math.ceil(n / 2) * 2;
    };
    return CroppedImageComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CroppedImageComponent.prototype, "width", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CroppedImageComponent.prototype, "image", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CroppedImageComponent.prototype, "text", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CroppedImageComponent.prototype, "alt", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CroppedImageComponent.prototype, "border", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CroppedImageComponent.prototype, "coefficient", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CroppedImageComponent.prototype, "radius", void 0);
CroppedImageComponent = __decorate([
    core_1.Component({
        selector: 'cropped-image',
        template: "\n      <div class=\"layout-column layout-align-center-center\"><div class=\"ci-cropper\" [style.width.px]=\"width\" [style.height.px]=\"width\"><div class=\"cropped-image\" [style.width.px]=\"width\" [style.height.px]=\"width\"><img *ngIf=\"image\" src=\"{{imageUrl}}\" [attr.style]=\"croppedImageStyle\"></div></div><div class=\"ci-footer text-center\" [class.ci-alt]=\"alt\" [style.margin-top.px]=\"textMargin\"> {{ text }}</div></div>\n    ",
        host: { '[style.position]': 'relative' },
    }),
    __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
], CroppedImageComponent);
exports.CroppedImageComponent = CroppedImageComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/cropped-image/cropped-image.component.js
// module id = 131
// module chunks = 0